import { z } from 'zod'

export const PointCentralConnectionSchema = z.object({
  haiku: z.string().min(1, 'Haiku is required'),
  password: z.string().min(1, 'Password is required'),
  username: z.string().min(1, 'Username is required'),
})

export type PointCentralConnectionFormValues = z.infer<typeof PointCentralConnectionSchema>

export const pointCentralDefaultValues: PointCentralConnectionFormValues = {
  haiku: '',
  password: '',
  username: '',
}
